export const getUserCases = (userId, limit) => `
SELECT
    Id,
    CaseNumber,
    CreatedDate,
    Imagem_Status__c,
    Status,
    Subject
FROM
    Case
WHERE
    OwnerId = '${userId}'
    AND Status NOT IN ('Resolvido', 'Fechado', 'Closed as Duplicate', 'Closed', 'Merged')
ORDER BY 
    CreatedDate DESC
    ${limit ? `LIMIT ${limit}` : ''}
`;
